<div class="mb-3 p-3 rounded border bg-white shadow-sm">

    <div class="d-flex align-items-center">
        <h5 class="mb-0">Participants</h5>
        <span class="tag-orange ml-3">Total Participants {{participantCount}}/{{maxParticipant}}</span>
        <span class="tag-grey ml-2">Contact Person {{contactCount}}/{{maxContact}}</span>
    </div>

    <div *ngFor="let p of participants.controls; let i = index" class="rounded border bg-white p-3 mb-2 mt-3">
        <ng-container *ngIf="p.value as item">
            <div class="d-flex align-items-center">
                <div>
                    <span id="participant-box-name-{{i}}" class="card-small-title-2">{{item.firstName}}</span>
                    <span>{{' '}}</span>
                    <span id="participant-box-lastname-{{i}}" class="card-small-title-2">{{item.lastName}}</span>
                    <span *ngIf="item.isParticipant" id="participant-box-speaker-tag-{{i}}" class="tag-blue ml-3">Speaker</span>
                    <span *ngIf="item.isAttendee" id="participant-box-attendee-tag-{{i}}" class="tag-orange ml-3">Attendee</span>
                    <span *ngIf="item.isContact" id="participant-box-contact-tag-{{i}}" class="tag-grey ml-3">Contact Person</span>
                </div>

                <div class="ml-auto d-flex align-items-center">
                    <button class="btn btn-sm btn-secondary mr-1" (click)="editParticipant(i)" [disabled]="isCloseRegister">
                        <i class="fas fa-pen icon-outline editor"></i>
                    </button>
                    <button class="btn btn-sm btn-danger" (click)="removeParticipant(i)" [disabled]="isCloseRegister">
                        <i class="fas fa-trash icon-outline trash"></i>
                    </button>
                </div>
            </div>
            <div class="mt-2">
                <span>
                    <i class="fas fa-envelope icon-outline"></i>
                    <span class="ml-2">{{item.email}}</span>
                </span>
                <span class="ml-4">
                    <i class="fas fa-phone icon-outline flip"></i>
                    <span class="ml-2">{{item.mobileNumber}}</span>
                    <span *ngIf="item.extNumber"> Ext. {{item.extNumber}}</span>
                </span>
                <span class="ml-4">
                    <i class="fas fa-suitcase icon-outline"></i>
                    <span class="ml-2">{{item.jobTitle}}</span>
                    <span *ngIf="item.department">/{{item.department}}</span>
                </span>
            </div>
        </ng-container>
    </div>
    

    <div class="d-flex justify-content-start mt-3">
        <button class="btn btn-primary" (click)="addParticipant()" [disabled]="hasReachedParticipantLimit() || isCloseRegister">
            <i class="fas fa-user-plus"></i>
            <span class="ml-2">Add Participants</span>
        </button>
    </div>
</div>

<div class="d-flex justify-content-end">
    <button class="btn btn-primary" (click)="onSubmit()" [disabled]="!canSaveParticipants || isCloseRegister">Save</button>
</div>